// extracted by mini-css-extract-plugin
export default {"checkIcon":"copyableText_checkIcon__3f9yU","copyButton":"copyableText_copyButton__kMG8y"};